import { useEffect } from 'react';
import { debugCoreLog, getCoreRuntimeMode } from '../config/runtimeMode.js';

export function useCanvasProjectionDebug({
  canvasEvidenceItems = [],
  effectiveCanvasReportTemplate,
  timelineItems = [],
  visibleCanvasAnalysisPayload,
} = {}) {
  useEffect(() => {
    const runtimeMode = getCoreRuntimeMode();
    debugCoreLog('canvas.projection', {
      mode: runtimeMode.mode,
      evidenceCount: canvasEvidenceItems.length,
      hasReportTemplate: Boolean(effectiveCanvasReportTemplate),
      hasAnalysisPayload: Boolean(visibleCanvasAnalysisPayload),
      timelineTypes: (Array.isArray(timelineItems) ? timelineItems : [])
        .map((item) => String(item?.type || '').trim())
        .filter(Boolean),
    });
  }, [canvasEvidenceItems.length, effectiveCanvasReportTemplate, timelineItems, visibleCanvasAnalysisPayload]);
}

export default useCanvasProjectionDebug;
